






















import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { LoyaltyRewardsPayload } from '@/models/sales-onboarding';

import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Typography,
    Checkbox
  }
})
export default class GiftCard extends Vue {
  @Prop() code!: string;
  @Prop() sellCoinsEnabled!: boolean;
  @Prop() loyaltRewards!: LoyaltyRewardsPayload;

  status = this.sellCoinsEnabled;

  loyaltRewardsData = this.loyaltRewards;

  get description() {
    if (
      this.loyaltRewardsData &&
      this.loyaltRewardsData.rewardPercentage &&
      this.status
    ) {
      return `With Loyalty active, Gift Card buyers earn ${
        this.loyaltRewardsData.rewardPercentage
      }% in Coins, boosting loyalty and repeat purchases.`;
    }

    return `Your business’ digital gift cards drive loyalty and repeat purchases.`;
  }

  changeToggle() {
    this.status = !this.status;

    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', {
      sellCoins: this.status
    });

    segmentIo.track(
      'Clicked on Toggle Gift Card/Sell Coins (Ownership experience)',
      {
        status: this.status
      }
    );
  }
}
